import { useEffect, useState } from 'react';
import { FormikProps } from 'formik/dist/types';

export type AppFormChangeEffectProps<DATA extends {}> = Pick<FormikProps<DATA>, 'dirty' | 'values'> & {
  onChange?(value: DATA): void;
};

export function AppFormChangeEffect<DATA extends {}>({ onChange, values, dirty }: AppFormChangeEffectProps<DATA>) {
  const [previousValues, setPreviousValues] = useState<DATA>();
  const [wasDirty, setWasDirty] = useState(dirty);

  useEffect(() => {
    if (dirty) {
      setWasDirty(true);
    }
  }, [dirty]);

  useEffect(() => {
    if (wasDirty && JSON.stringify(previousValues) !== JSON.stringify(values)) {
      onChange?.(values);
      setPreviousValues(values);
    }
  }, [wasDirty, onChange, previousValues, values]);

  return null;
}
